module.exports = __webpack_public_path__ + "img/confirm.c884f427.svg";